"use client";

import { c as _c } from "react/compiler-runtime";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { INotificationDropReplied } from "@/types/feed.types";
import NotificationWithDrop from "../subcomponents/NotificationWithDrop";
export default function NotificationDropReplied(t0) {
  const $ = _c(6);
  const {
    notification,
    activeDrop,
    onReply,
    onDropContentClick
  } = t0;
  const replyDrop = notification.related_drops?.[1];
  if (!replyDrop) {
    return null;
  }
  let t1;
  if ($[0] !== activeDrop || $[1] !== notification.created_at || $[2] !== onDropContentClick || $[3] !== onReply || $[4] !== replyDrop) {
    t1 = <NotificationWithDrop drop={replyDrop} actionText="replied" createdAt={notification.created_at} activeDrop={activeDrop} onReply={onReply} onDropContentClick={onDropContentClick} />;
    $[0] = activeDrop;
    $[1] = notification.created_at;
    $[2] = onDropContentClick;
    $[3] = onReply;
    $[4] = replyDrop;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}